import React from 'react';
import cn from 'classnames';
import { useField } from 'informed';

import { InternationalMobileNumber } from '@nw/omega-design-system';
import { PHONE } from '@nw/shared/config';

import { FieldContainer } from './styledComponents';

import './styles.css';

interface InternationalPhoneNumberFieldPropTypes {
  label: string;
  field: string;
  error: string;
  touched: boolean;
  isDisabled: boolean;
  validationSchemaObject: any;
  isHidden?: boolean;
  fieldWrapperStyles?: string;
  wrapperWithPopOverStyles?: string;
  popOverStyle?: string;
  intlPhoneNumberFieldStyles?: string;
  fieldContainerStyles?: string;
  allowedCountriesList?: string[];
  initialCountryCode?: string;
  phoneNumberInputStyles?: string;
  intlPhoneNumberContainerStyles?: string;
  listBoxStyles?: string;
  popOverStyles?: string;
  initialMobileNumber?: string;
  values?: any;
  t?;
  placeholder?: string;
  reRenderedFieldsObjects?: any;
  helperText?: string;
  autoFocus?: boolean;
  helperTextStyles?: string;
  fieldValidations: any;
  countryCodeField?: string;
  dialCodeField?: string;
  validateOnBlur?: boolean;
  labelStyles?: string;
  inputFieldStyles?: string;
  errorMessageStyles?: string;
  isMarginBottomZero?: boolean;
  handleFocus?: (e) => void;
  handleBlur?: (e) => void;
}

const InformedInternationalPhoneNumberField = (
  props: InternationalPhoneNumberFieldPropTypes
) => {
  const {
    label,
    field,
    error,
    touched,
    isDisabled,
    isHidden,
    fieldWrapperStyles,
    popOverStyle,
    wrapperWithPopOverStyles,
    intlPhoneNumberFieldStyles,
    fieldContainerStyles,
    allowedCountriesList,
    initialCountryCode,
    phoneNumberInputStyles,
    intlPhoneNumberContainerStyles,
    listBoxStyles,
    popOverStyles,
    initialMobileNumber,
    placeholder,
    helperText,
    validationSchemaObject,
    helperTextStyles,
    autoFocus,
    fieldValidations,
    countryCodeField,
    dialCodeField,
    labelStyles,
    validateOnBlur = true,
    inputFieldStyles,
    errorMessageStyles,
    isMarginBottomZero,
    handleFocus,
    handleBlur
  } = props;

  const {
    fieldApi: dialCodeFieldApi,
    fieldState: dialCodeFieldState,
    informed: dialCodeInformed
  } = useField({
    field: dialCodeField ? dialCodeField : 'dialCode',
    validateOnBlur: true,
    validateOnChange: true,
    //@ts-ignore
    validationSchema:
      validationSchemaObject.fields[dialCodeField ? dialCodeField : 'dialCode'],
    error
  });

  const {
    fieldApi: countryCodeFieldApi,
    fieldState: countryCodeFieldState,
    informed: countryCodeInformed
  } = useField({
    field: countryCodeField ? countryCodeField : 'countryCode',
    validateOnBlur: true,
    validateOnChange: true,
    //@ts-ignore
    validationSchema:
      validationSchemaObject.fields[
        countryCodeField ? countryCodeField : 'countryCode'
      ],
    error
  });

  const { setValue: setDialCode } = dialCodeFieldApi;

  const { setValue: setCountryCode } = countryCodeFieldApi;

  const { value: countryCode } = countryCodeFieldState;
  const { value: dialCode } = dialCodeFieldState;

  //@ts-ignore
  const { fieldState, render, informed, fieldApi } = useField({
    field,
    validateOnBlur: validateOnBlur,
    validateOnChange: true,
    //@ts-ignore
    validationSchema: validationSchemaObject.fields[field],
    error,
    isDisabled,
    label,
    dialCode,
    countryCode,
    ...fieldValidations
  });

  const { value: phoneNumber } = fieldState;

  const { onBlur, onChange } = informed;
  const { onChange: dialCodeOnChange } = dialCodeInformed;
  const { onChange: countryCodeOnChange } = countryCodeInformed;
  const { setValue } = fieldApi;

  const formatePhoneNumber = (phoneNumber: string) => {
    const countryCodePattern = /^(?:\+91|0)/;
    const hasCountryCode = countryCodePattern.test(phoneNumber);
    let cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');
    if (
      cleanedPhoneNumber &&
      hasCountryCode &&
      cleanedPhoneNumber.length > 10
    ) {
      cleanedPhoneNumber = cleanedPhoneNumber.slice(-10);
    }
    setValue(cleanedPhoneNumber);
    onChange(cleanedPhoneNumber);
  };

  const renderInternationalPhoneNumberField = () => (
    <>
      <InternationalMobileNumber
        //@ts-ignore
        phoneNumber={phoneNumber}
        countryCode={countryCode as string}
        dialCode={dialCode as string}
        label={label}
        wrapperWithPopOverStyles={wrapperWithPopOverStyles}
        popOverStyle={popOverStyle}
        onChangePhoneNumber={(phoneNumber) => {
          formatePhoneNumber(phoneNumber);
        }}
        onChangeDialCode={(value) => {
          setDialCode(value);
          dialCodeOnChange(value);
        }}
        onChangeCountryCode={(value) => {
          setCountryCode(value);
          countryCodeOnChange(value);
        }}
        intlPhoneNumberFieldStyles={intlPhoneNumberFieldStyles}
        fieldContainerStyles={fieldContainerStyles}
        allowedCountriesList={allowedCountriesList}
        phoneNumberInputStyles={phoneNumberInputStyles}
        intlPhoneNumberContainerStyles={intlPhoneNumberContainerStyles}
        listBoxStyles={cn('dropdown-styles', listBoxStyles)}
        onBlur={(e) => {
          onBlur(e);
          handleBlur && handleBlur(e);
        }}
        isDisabled={isDisabled}
        errorMessage={error}
        getCustomLabelForSelectedOption={(option) => option.value.value}
        placeholder={placeholder}
        helperText={helperText}
        autoFocus={autoFocus}
        mobileListBoxStyles={cn('overflow-y-auto')}
        isSearchable={true}
        helperTextStyles={helperTextStyles}
        popOverStyles={cn('max-h-250px', popOverStyles)}
        labelStyles={labelStyles}
        inputFieldStyles={inputFieldStyles}
        errorMessageStyles={errorMessageStyles}
        handleFocus={(e) => {
          handleFocus && handleFocus(e);
        }}
        name={PHONE}
      />
    </>
  );

  return render(
    <FieldContainer
      key={field}
      isHidden={isHidden}
      css={fieldWrapperStyles}
      isMarginBottomZero={isMarginBottomZero}
    >
      {renderInternationalPhoneNumberField()}
    </FieldContainer>
  );
};

export { InformedInternationalPhoneNumberField };
